import React from 'react';
import PropTypes from 'prop-types';
import localization from '../../../locales/localization';

const styles = {
    datumImjesto: {
        fontSize: 10,
        margin: 0
    }
};

class DatumIMjestoRacun extends React.Component {
    render() {
        return (
            <div>
                <p style={styles.datumImjesto}>
                    {localization.printingComponents.common.mjestoIzdavanja + ': '}
                    <b>{this.props.mjesto}</b>
                </p>
                <p style={styles.datumImjesto}>
                    {localization.printingComponents.common.datumIzdavanja + ': '}
                    <b>{this.props.datum}</b>
                </p>
                <p style={styles.datumImjesto}>
                    {localization.printingComponents.common.vrijemeIzdavanja + ': '}
                    <b>{this.props.vrijeme}</b>
                </p>
            </div>
        );
    }
}

DatumIMjestoRacun.propTypes = {
    mjesto: PropTypes.string.isRequired,
    datum: PropTypes.string.isRequired,
    vrijeme: PropTypes.string.isRequired
};

export default DatumIMjestoRacun;
